import React from 'react';

import { useBooking } from '@/booking';
import { BookingRequest } from '@/booking/interfaces';
import { useHotel } from '@/hotel';
import { useTranslation } from '@/i18n';

import { ConfirmationHeader } from './ConfirmationHeader.component';

interface AsyncPaymentConfirmationHeaderProps {
  bookingRequest: BookingRequest;
}

export function AsyncPaymentConfirmationHeader({
  bookingRequest,
}: AsyncPaymentConfirmationHeaderProps) {
  const booking = useBooking(bookingRequest);
  const hotel = useHotel(bookingRequest.hotelSlug);
  const { t } = useTranslation(['confirmation']);

  if (!booking || !hotel) return null;

  return (
    <ConfirmationHeader
      title={t('confirmation:asyncPayment.title')}
      subtitle={t('confirmation:asyncPayment.subtitle')}
      confirmationMessage={t('confirmation:asyncPayment.emailMessage', {
        email: booking.firstRoomStay.billerProfile.email,
      })}
      headerImage={hotel.content.images.header}
    />
  );
}
